import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneModal = (props) =>
{
    return(<div>
  
        <Modal open={props.open} onClose={props.onCloseModal} center classNames={{
          modal: 'customModal',
        }}>
         <div className='modal-header'><h3 className='modal-title'>Change Phone Number</h3></div>
         <div className='modal-body'> 
         <form className="mt-1" style={{minWidth:"320px"}}>
             
                
         <div className="form-group">
                            <label>Phone Number</label>
                            <PhoneInput
                              required
                            />
                          </div>

                      <div className="form-group">
                      <input
                          type="text"
                          className="form-control mb-0"
                          id="Otp"
                          name="otp"
                          placeholder={"Enter OTP"}
                          autoComplete="off"
                          required
                         
                        />
                      </div>

                   
                      <div className="sign-info">
                        {/*   <div className="custom-control custom-checkbox d-inline-block">
                        <input type="checkbox" className="custom-control-input" id="customCheck" />
                        <label className="custom-control-label" htmlFor="customCheck">Remember Me</label>
                     
                     
                     </div>     */}
                        <button
                          type="submit"
                          className="btn btn-hover"
                          style={{ float: "right" }}
                        >
                         Verify and Change
                        </button>
                      </div>
                    </form>
         </div>
      
        </Modal>
      </div>);

    
}

export default PhoneModal